interface FlattenTreeOptions {
  valueField?: string
  childrenField?: string
}

/**
 * Depth-first traversal that returns tree node keys as a flat list in visual order.
 * Used for calculating range selections between two nodes.
 */
export function flattenTree<T>(nodes: T[], options?: FlattenTreeOptions): string[] {
  const valueField = options?.valueField ?? 'value'
  const childrenField = options?.childrenField ?? 'children'
  const result: string[] = []

  const traverse = (items: T[]) => {
    for (const item of items) {
      const record = item as Record<string, any>
      result.push(String(record[valueField]))
      const children = record[childrenField]
      if (Array.isArray(children)) {
        traverse(children)
      }
    }
  }

  traverse(nodes)
  return result
}
